import React from "react";
import styled from "styled-components";
import { Colors } from "./styles/Colors";
import { ProximaNova } from "./typography";

const Wrapper = styled.div`
  display: inline-flex;

  margin: 20px 0;
`;

const Segment = styled.button`
  width: 160px;
  height: 56px;

  display: flex;

  justify-content: center;
  align-items: center;

  appearance: none;

  outline: none;

  cursor: pointer;

  background: ${(props) => (props.active ? Colors.hunter : "none")};
  border: 1px solid ${Colors.webGrey};

  color: ${(props) => (props.active ? Colors.yellow : Colors.greyLight)};

  font-family: ${ProximaNova};
  font-size: 12px;
  text-transform: uppercase;

  svg {
    margin-right: 8px;
  }

  &:first-child {
    border-top-left-radius: 28px;
    border-bottom-left-radius: 28px;

    border-right: 0;

    svg {
      width: 22px;
      height: 22px;
    }
  }

  &:last-child {
    border-top-right-radius: 28px;
    border-bottom-right-radius: 28px;

    border-left: 0;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export default function SegmentControl({ active, setActive, data }) {
  return (
    <Wrapper>
      <Segment onClick={() => setActive(0)} active={active === 0}>
        { data.left }
      </Segment>
      <Segment onClick={() => setActive(1)} active={active === 1}>
        { data.right }
      </Segment>
    </Wrapper>
  );
}
